import React, { useState } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import Swal from "sweetalert2";
const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

export const Addnewidea = () => {
  let navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const onChange = (e) => {
    let temp = Object.assign(data, { [e.target.name]: e.target.value });
    setData(temp);
    console.log("updated data>> ", temp);
  };
  const submitData = (e) => {
    e.preventDefault();
    let errs = {};
    if (!data.title) {
      errs.title = "required";
    }
    if (!data.projectType) {
      errs.projectType = "required";
    }
    if (!data.techUsed) {
      errs.techUsed = "required";
    }
    // if (!data.projectLink) {
    //   errs.projectLink = "required";
    // }
    if (!data.description) {
      errs.description = "required";
    }
    setErrors(errs);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      let body = Object.assign(data, {
        userId: currentUser?.id,
        isAlreadyCreated: false,
      });
      console.log("submitting data", body);
      api
        .post("/FYPs", body)
        .then((res) => {
          console.log(res.data);
          Swal.fire("FYP Added Successfully!", "", "success");
          let notifBody = {
            userId: currentUser?.id,
            text: `${currentUser?.name} added new FYP.`,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.href = "/fyp/listnew";
        })
        .catch((err) => {
          console.log(err);
          swalWithBootstrapButtons.fire(
            "FYP Uploading Unsuccessful!",
            "Something goes wrong",
            "error"
          );
        });
    }
  };

  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-10 col-12">
          <div className="container">
            <Typography className="my-4" variant="h6" sx={{ fontSize: "600" }}>
              Add New Idea
            </Typography>
            <div className="form">
              <div className="col-lg-8 col-12 m-auto">
                <div className="row">
                  <div className="col-lg-6 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="title"
                      placeholder="Title"
                      type={"text"}
                      id="title"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.title && (
                      <p className="error__para">{errors.title}</p>
                    )}
                  </div>
                  <div className="col-lg-6 col-12">
                    <select
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="projectType"
                      onChange={(e) => onChange(e)}
                    >
                      <option value="">Project Type</option>
                      <option value="Mobile Application">
                        Mobile Application
                      </option>
                      <option value="Web Application">Web Application</option>
                      <option value="Desktop Application">
                        Desktop Application
                      </option>
                      <option value="Game Development">Game Development</option>
                      <option value="Research Work">Research Work</option>
                      <option value="Data Science">Data Science</option>
                      <option value="Machine Learning">Machine Learning</option>
                      <option value="Artificial Intelligence">
                        Artificial Intelligence
                      </option>
                    </select>
                    {errors.projectType && (
                      <p className="error__para">{errors.projectType}</p>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="techUsed"
                      placeholder="Technology Used (Stack)"
                      id="techUsed"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.techUsed && (
                      <p className="error__para">{errors.techUsed}</p>
                    )}
                  </div>
                  <div className="col-lg-6 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="projectLink"
                      placeholder="Related Work Link"
                      // id="projectlink"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.projectLink && (
                      <p className="error__para">{errors.projectLink}</p>
                    )}
                  </div>
                </div>

                <textarea
                  className="p-2 border border-dark rounded my-2 w-full text-area  input__field__asc"
                  name="description"
                  placeholder="Description"
                  id="description"
                  required
                  onChange={(e) => onChange(e)}
                ></textarea>
                {errors.description && (
                  <p className="error__para">{errors.description}</p>
                )}
                <button
                  className=" asc__submit__form__button cancel__form__btn"
                  onClick={() => navigate("/fyp")}
                >
                  Cancel
                </button>
                <button
                  className=" mt-3 asc__submit__form__button"
                  onClick={(e) => submitData(e)}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
